// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__37ufp","dot":"styles_dot__1mPbS"};